export const chartData = {
  dates: [
    "Mon 00:00",
    "Mon 01:00",
    "Mon 02:00",
    "Mon 03:00",
    "Mon 04:00",
    "Mon 05:00",
    "Mon 06:00",
    "Mon 07:00",
    "Mon 08:00",
    "Mon 09:00",
    "Mon 10:00",
    "Mon 11:00",
    "Mon 12:00",
    "Mon 13:00",
    "Mon 14:00",
    "Mon 15:00",
    "Mon 16:00",
    "Mon 17:00",
    "Mon 18:00",
    "Mon 19:00",
    "Mon 20:00",
    "Mon 21:00",
    "Mon 22:00",
    "Mon 23:00",
    "Tue 00:00",
    "Tue 01:00",
    "Tue 02:00",
    "Tue 03:00",
    "Tue 04:00",
    "Tue 05:00",
    "Tue 06:00",
    "Tue 07:00",
    "Tue 08:00",
    "Tue 09:00",
    "Tue 10:00",
    "Tue 11:00",
    "Tue 12:00",
    "Tue 13:00",
    "Tue 14:00",
    "Tue 15:00",
    "Tue 16:00",
    "Tue 17:00",
    "Tue 18:00",
    "Tue 19:00",
    "Tue 20:00",
    "Tue 21:00",
    "Tue 22:00",
    "Tue 23:00",
    "Wed 00:00",
    "Wed 01:00",
    "Wed 02:00",
    "Wed 03:00",
    "Wed 04:00",
    "Wed 05:00",
    "Wed 06:00",
    "Wed 07:00",
    "Wed 08:00",
    "Wed 09:00",
    "Wed 10:00",
    "Wed 11:00",
    "Wed 12:00",
    "Wed 13:00",
    "Wed 14:00",
    "Wed 15:00",
    "Wed 16:00",
    "Wed 17:00",
    "Wed 18:00",
    "Wed 19:00",
    "Wed 20:00",
    "Wed 21:00",
    "Wed 22:00",
    "Wed 23:00",
    "Thu 00:00",
    "Thu 01:00",
    "Thu 02:00",
    "Thu 03:00",
    "Thu 04:00",
    "Thu 05:00",
    "Thu 06:00",
    "Thu 07:00",
    "Thu 08:00",
    "Thu 09:00",
    "Thu 10:00",
    "Thu 11:00",
    "Thu 12:00",
    "Thu 13:00",
    "Thu 14:00",
    "Thu 15:00",
    "Thu 16:00",
    "Thu 17:00",
    "Thu 18:00",
    "Thu 19:00",
    "Thu 20:00",
    "Thu 21:00",
    "Thu 22:00",
    "Thu 23:00",
    "Fri 00:00",
    "Fri 01:00",
    "Fri 02:00",
    "Fri 03:00",
    "Fri 04:00",
    "Fri 05:00",
    "Fri 06:00",
    "Fri 07:00",
    "Fri 08:00",
    "Fri 09:00",
    "Fri 10:00",
    "Fri 11:00",
    "Fri 12:00",
    "Fri 13:00",
    "Fri 14:00",
    "Fri 15:00",
    "Fri 16:00",
    "Fri 17:00",
    "Fri 18:00",
    "Fri 19:00",
    "Fri 20:00",
    "Fri 21:00",
    "Fri 22:00",
    "Fri 23:00",
    "Sat 00:00",
    "Sat 01:00",
    "Sat 02:00",
    "Sat 03:00",
    "Sat 04:00",
    "Sat 05:00",
    "Sat 06:00",
    "Sat 07:00",
    "Sat 08:00",
    "Sat 09:00",
    "Sat 10:00",
    "Sat 11:00",
    "Sat 12:00",
    "Sat 13:00",
    "Sat 14:00",
    "Sat 15:00",
    "Sat 16:00",
    "Sat 17:00",
    "Sat 18:00",
    "Sat 19:00",
    "Sat 20:00",
    "Sat 21:00",
    "Sat 22:00",
    "Sat 23:00",
    "Sun 00:00",
    "Sun 01:00",
    "Sun 02:00",
    "Sun 03:00",
    "Sun 04:00",
    "Sun 05:00",
    "Sun 06:00",
    "Sun 07:00",
    "Sun 08:00",
    "Sun 09:00",
    "Sun 10:00",
    "Sun 11:00",
    "Sun 12:00",
    "Sun 13:00",
    "Sun 14:00",
    "Sun 15:00",
    "Sun 16:00",
    "Sun 17:00",
    "Sun 18:00",
    "Sun 19:00",
    "Sun 20:00",
    "Sun 21:00",
    "Sun 22:00",
    "Sun 23:00",
  ],
  values: [
    3713, 3541, 3428, 3272, 3479, 4752, 6797, 8884, 10290, 10789, 9841, 9436,
    9033, 8885, 9301, 9815, 10554, 11298, 12244, 11973, 11104, 9898, 7625, 5326,
    3549, 3451, 3346, 3341, 3513, 4802, 6999, 8931, 10247, 10799, 10057, 9513,
    9163, 8866, 9493, 9797, 10426, 11428, 12103, 11821, 11146, 9971, 7408, 5306,
    3650, 3538, 3385, 3359, 3503, 4733, 6813, 8658, 10195, 10661, 9991, 9475,
    9078, 8886, 9298, 9647, 10331, 11062, 12014, 11509, 11205, 9864, 7588, 5317,
    3792, 3617, 3461, 3485, 3698, 4908, 7064, 8953, 10403, 11242, 10165, 9656,
    9457, 9188, 9569, 10012, 10621, 11360, 12178, 12084, 11339, 10164, 7708,
    5591, 3745, 3636, 3499, 3460, 3751, 5023, 7184, 9306, 10920, 11346, 10428,
    10055, 9558, 9405, 9877, 10426, 10785, 11852, 12314, 12191, 11607, 10187,
    7980, 5854, 3350, 3312, 3228, 3151, 3322, 4363, 6143, 7767, 8913, 9456,
    8918, 8418, 8061, 7945, 8412, 8785, 9535, 10004, 10806, 10523, 9871, 9021,
    6984, 5056, 3291, 3240, 3059, 3043, 3201, 4358, 5955, 7669, 8746, 9259,
    8633, 8316, 7860, 7776, 8027, 8484, 9120, 9922, 10607, 9982, 9529, 8794,
    6819, 4822,
  ],
};

export const metricsData = [
  {
    label: "Total (7 days)",
    value: "1334.47 MWh",
    color: "#000",
    subLabel: "",
  },
  {
    label: "Avg. Hourly",
    value: "7,943.30 kWh",
    color: "#000",
    subLabel: "",
  },
  {
    label: "Peak Hour",
    value: "12,314 kWh",
    color: "#1064ED",
    subLabel: "Fri, 18:00",
  },
  {
    label: "Off-Peak Low",
    value: "3,043 kWh",
    color: "#6B7280",
    subLabel: "Sun, 03:00",
  },
];
